import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../withRouter';
import actions from '../../../actions';
import {
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardTitle,
  CCardText,
  CImage,
} from '@coreui/react';
import Button from '../../Common/HtmlTags/Button';
import resolveImage from '../../store/ResolveImage';
import { API_URL } from '../../../constants';
import { useNavigate, Link } from 'react-router-dom';
import ManagerPagination from '../Pagination';
import LoadingIndicator from '../../store/LoadingIndicator';

const ManagerTeamMembersHelper = (props) => {
  const {
    isLightMode,
    teamMembersList = [],
    isLoading,
  } = props;
  const navigate = useNavigate();
  const membersPerPage = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(teamMembersList.length / membersPerPage);
  const startIndex = (currentPage - 1) * membersPerPage;
  const endIndex = startIndex + membersPerPage;
  const currentMembers = teamMembersList.slice(startIndex, endIndex);

  return (
    <div data-aos='fade-up' className='container-lg px-4 d-flex flex-column mb-custom-5em team-members-manager'>
      {isLoading && <LoadingIndicator isLightMode={isLightMode} />}
      <div className='team-members-header d-flex justify-content-between align-items-center'>
        <h2 style={{ margin: 0 }} className={`${isLightMode ? 'p-black' : 'p-white'}`}>
          Team Members
        </h2>
        <Button
          onClick={() => navigate('/dashboard/team-members/add')}
          type='third-btn'
          text='Add Team Member +'
        />
      </div>
      <hr className={`${isLightMode ? 'p-black' : 'p-white'}`} />

      {!isLoading && currentMembers.length === 0 && (
        <p className={`${isLightMode ? 'p-black' : 'p-white'}`}>No team members yet. Add the first one.</p>
      )}

      <CRow className='gy-4'>
        {currentMembers.map((member) => (
          <CCol xs={12} md={6} key={member._id}>
            <Link to={`/dashboard/team-members/edit/${member._id}`} style={{ textDecoration: 'none' }}>
              <CCard
                className={`${isLightMode ? 'bg-white p-black' : 'bg-black p-white border'} team-member-card flex-row overflow-hidden`}
              >
                <CImage
                  src={resolveImage(member.imageUrl ? `${API_URL}${member.imageUrl}` : '', 'profile')}
                  alt={member.name}
                  className='team-member-card-image'
                />
                <CCardBody className='team-member-card-body'>
                  <CCardTitle className='mb-1'>{member.name}</CCardTitle>
                  <p className='team-member-role mb-2'>{member.role}</p>
                  <CCardText className='team-member-bio mb-0'>
                    {member.bio}
                  </CCardText>
                </CCardBody>
              </CCard>
            </Link>
          </CCol>
        ))}
      </CRow>

      <ManagerPagination
        isLightMode={isLightMode}
        data={teamMembersList}
        totalPages={totalPages}
        startIndex={startIndex}
        endIndex={endIndex}
        onPageChange={setCurrentPage}
      />
    </div>
  );
};

class ManagerTeamMembers extends React.PureComponent {
  componentDidMount() {
    this.props.fetchTeamMembers();
  }

  render() {
    return <ManagerTeamMembersHelper {...this.props} />;
  }
}

const mapStateToProps = (state) => ({
  teamMembersList: state.teamMembers.teamMembersList,
  isLoading: state.teamMembers.isLoading,
  isLightMode: state.dashboard.isLightMode,
});

export default connect(mapStateToProps, actions)(withRouter(ManagerTeamMembers));
